"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateProduct = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../classes/com/tmpls");
const StatePaged_1 = require("../../classes/states/abstracts/StatePaged");
const App_1 = require("../../classes/App");
const State404_1 = require("./State404");
const Helper_1 = require("../../classes/Helper");
const BreadCrumb_1 = require("../../classes/models/BreadCrumb");
const StateCatalog_1 = require("./StateCatalog");
const ClassesTags_1 = require("../../classes/ClassesTags");
const FilesTags_1 = require("../../classes/FilesTags");
const FavoriteController_1 = require("../controllers/FavoriteController");
const CartController_1 = require("../controllers/CartController");
const GUIControllerPM_1 = require("../controllers/GUIControllerPM");
class StateProduct extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageProduct, "ПрофиМолл", true);
        this._qty = 1;
        const ctrl = this.page.ctrls;
        ctrl.btnTabMain.onclick = () => { this._selectTab(ctrl.btnTabMain); history.replaceState({}, this.title, `/product/${this._product.id}`); };
        ctrl.btnTabReviews.onclick = () => { this._selectTab(ctrl.btnTabReviews); };
        ctrl.btnTabDetails.onclick = () => { this._selectTab(ctrl.btnTabDetails); history.replaceState({}, this.title, `/product/${this._product.id}/details`); };
        ctrl.btnTabQuestions.onclick = () => { this._selectTab(ctrl.btnTabQuestions); };
        // ctrl.btnTabFiles.onclick=()=>{clearTabs();ctrl.cmpTabMain.show();};
        ctrl.btnFavorite.onclick = (e) => {
            gs.events.stop(e);
            const favoriteCtrl = this.app.getInst(FavoriteController_1.FavoriteController);
            let isFavorite = favoriteCtrl.isFavorite(this._product.id);
            if (isFavorite)
                favoriteCtrl.removeFavorite(this._product.id);
            else
                favoriteCtrl.addFavorite(this._product.id);
            this._setFavorite(!isFavorite);
        };
        ctrl.blockImgPreview.el.addEventListener('mousemove', function (e) {
            const rect = ctrl.blockImgPreview.el.getBoundingClientRect();
            const x = (e.clientX - rect.left) / rect.width;
            const y = (e.clientY - rect.top) / rect.height;
            const zoom = 2;
            // Вычисляем смещение в процентах от центра
            const offsetX = (0.5 - x) * 100 * (zoom - 1);
            const offsetY = (0.5 - y) * 100 * (zoom - 1);
            ctrl.imgPreview.el.style.transform = `scale(${zoom}) translate(${offsetX / zoom}%, ${offsetY / zoom}%)`;
        });
        ctrl.blockImgPreview.el.addEventListener('mouseleave', () => {
            ctrl.imgPreview.el.style.transform = 'scale(1) translate(0, 0)';
        });
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (!(args && args.path1)) {
                yield gs.StateGS.Run(State404_1.State404);
                return gs.StateRunResultEnum.Skipped;
            }
            const product = yield App_1.App.Inst.cache.getProductAsync(parseInt(args.path1));
            if (!product) {
                yield gs.StateGS.Run(State404_1.State404);
                return gs.StateRunResultEnum.Skipped;
            }
            this._product = product;
            if (this._product.nameSEO)
                this.title = "Профимолл - " + this._product.nameSEO;
            else
                this.title = "Профимолл - " + this._product.name;
            this._urlArgs["path0"] = args.path0;
            this._urlArgs["path1"] = args.path1;
            if (args.path2)
                this._urlArgs["path2"] = args.path2;
            //TODO оптимизировать
            let crumbs = [];
            crumbs.unshift(new BreadCrumb_1.BreadCrumb(product.name, `${StateProduct.StateName}/${product.id}`));
            let category = yield App_1.App.Inst.cache.getCategoryAsync(this._product.categoryId);
            if (category) {
                crumbs.unshift(new BreadCrumb_1.BreadCrumb(category.name, `${StateCatalog_1.StateCatalog.StateName}/${category.id}`));
                while (category.parentId) {
                    const result = yield App_1.App.Inst.cache.getCategoryAsync(category.parentId);
                    if (!result)
                        break;
                    category = result;
                    crumbs.unshift(new BreadCrumb_1.BreadCrumb(category.name, `${StateCatalog_1.StateCatalog.StateName}/${category.id}`));
                }
            }
            crumbs.unshift(new BreadCrumb_1.BreadCrumb("Главная", "/"));
            this.app.getInst(GUIControllerPM_1.GUIControllerPM).setBreadcrumbs(crumbs);
            this._loadAsync();
            return _super.start.call(this);
        });
    }
    _loadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const ctrl = this.page.ctrls;
            if (this.app.getInst(FavoriteController_1.FavoriteController).isFavorite(this._product.id))
                ctrl.btnFavorite.addClass(ClassesTags_1.ClassesTags.Active);
            else
                ctrl.btnFavorite.removeClass(ClassesTags_1.ClassesTags.Active);
            //Задаем статус
            [ctrl.statusOk, ctrl.statusNone, ctrl.statusDelivery].forEach(s => s.hide());
            if (this._product.remainder <= 0) {
                ctrl.statusNone.show();
                ctrl.btnAddToCart.disable();
            }
            else
                ctrl.statusOk.show();
            //TODO временное(удалить потом) 
            ctrl.lRemainderCount.text = this._product.remainder + "";
            if (this._product.nameSEO)
                ctrl.lName.text = this._product.nameSEO;
            else
                ctrl.lName.text = this._product.name;
            if (this._product.rate < 0)
                ctrl.blockRate.hide();
            else
                ctrl.lRate.text = this._product.rate + "";
            //TODO сделать получение полного объекта с заполнением данных
            ctrl.lReviewsCount.text = "0";
            ctrl.lQuestionsCount.text = "0";
            //TODO переключение состояния
            ctrl.aQuestions.el.onclick = (e) => { gs.events.stop(e); };
            ctrl.aReviews.el.onclick = (e) => { gs.events.stop(e); };
            ctrl.lArticle.text = this._product.article;
            //TODO сделать сравнение
            ctrl.btnCompare.hide();
            ctrl.btnShare.addClass('not_implemented');
            ctrl.btnGalleryNext.addClass('not_implemented');
            ctrl.btnGalleryPrev.addClass('not_implemented');
            ctrl.lBtnReviewsCount.text = "";
            ctrl.lBtnQuestionsCount.text = "";
            ctrl.lBtnFilesCount.text = "";
            ctrl.aDetails.el.setAttribute('href', `/product/${this._product.id}/details`);
            ctrl.aQuestions.el.setAttribute('href', `/product/${this._product.id}/questions`);
            ctrl.aReviews.el.setAttribute('href', `/product/${this._product.id}/reviews`);
            this._addDetail("Артикул", this._product.article);
            if (this._product.weightKg)
                this._addDetail("Вес, кг", Helper_1.Helper.toVolWeightString(this._product.weightKg));
            if (this._product.volumeM)
                this._addDetail("Объем, м.куб", Helper_1.Helper.toVolWeightString(this._product.volumeM));
            if (this._product.brand && this._product.brand.name)
                this._addDetail("Бренд", this._product.brand.name);
            ctrl.blockPriceBonus.hide();
            ctrl.lPrice.text = Helper_1.Helper.toPriceString(this._product.price);
            ctrl.lPriceOld.hide();
            ctrl.btnQtyMinus.onclick = () => this._setQty(this._qty - 1);
            ctrl.btnQtyPlus.onclick = () => this._setQty(this._qty + 1);
            if (this._product.remainder == 0)
                this._qty = 0;
            this._setQty(this._qty);
            if (this._product.descriptionSEO)
                ctrl.cmpTabMain.ctrls.lDescription.text = this._product.descriptionSEO;
            else
                ctrl.cmpTabMain.ctrls.lDescription.text = this._product.description;
            const mainFoto = this._product.fotos.find(f => f.tag == FilesTags_1.FilesTags.ImgMain);
            if (mainFoto) {
                this.page.ctrls.listImgs.html = '';
                this._addFoto(mainFoto, true);
            }
            this.page.ctrls.btnAddToCart.onclick = () => {
                this.app.getInst(CartController_1.CartController).addProduct(this._product.id, this._qty, this._product.weightKg);
                this._setQty(1);
            };
            const tab = this._urlArgs["path2"];
            if (!tab)
                this._selectTab(ctrl.btnTabMain);
            else if (tab.toLowerCase() == "details")
                this._selectTab(ctrl.btnTabDetails);
            //TODO
            // else if (tab.toLowerCase()=="details") ctrl.btnTabDetails.el.click();
            // else if (tab.toLowerCase()=="details") ctrl.btnTabDetails.el.click();
            gs.StateGS.CatchLinks();
            this._catchLinksOverride();
        });
    }
    _addFoto(foto, withPreview = false) {
        if (withPreview)
            this.page.ctrls.imgPreview.src = "/fs/products/" + foto.id;
        const li = gs.w(gs.html.tag("li", { class: "pagination_item" }));
        const img = gs.w(gs.html.img({ src: "/fs/products/pv256/" + foto.id, tag: "1" }));
        li.append(img);
        this.page.ctrls.listImgs.append(li);
    }
    _catchLinksOverride() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Helper_1.Helper.awaitTime(500);
            const ctrl = this.page.ctrls;
            ctrl.aDetails.onclick = (e) => __awaiter(this, void 0, void 0, function* () {
                gs.events.stop(e);
                ctrl.btnTabDetails.el.click();
                Helper_1.Helper.scrollTo(ctrl.btnTabDetails, -180);
            });
        });
    }
    _setQty(qty) {
        if (qty < 0)
            return;
        if (this._product.remainder < qty)
            return;
        this._qty = qty;
        const ctrl = this.page.ctrls;
        ctrl.lPriceTotal.text = Helper_1.Helper.toPriceString(this._product.price * this._qty);
        ctrl.lQty.text = this._qty + "";
        if (this._qty == 1)
            ctrl.btnQtyMinus.disable();
        else
            ctrl.btnQtyMinus.enable();
    }
    _setFavorite(value) {
        const btn = this.page.ctrls.btnFavorite;
        if (value)
            btn.addClass(ClassesTags_1.ClassesTags.Active);
        else
            btn.removeClass(ClassesTags_1.ClassesTags.Active);
    }
    _addDetail(name, value) {
        let item = new com.CmpProductDetailItem();
        item.ctrls.lName.text = name + ":";
        item.ctrls.lValue.text = value;
        item.ctrls.btnArticle.hide();
        this.page.ctrls.list.append(item);
        item = new com.CmpProductDetailItem();
        item.ctrls.lName.text = name + ":";
        item.ctrls.lValue.text = value;
        item.ctrls.btnArticle.hide();
        this.page.ctrls.cmpTabDetails.ctrls.list.append(item);
    }
    _selectTab(btn) {
        const ctrl = this.page.ctrls;
        const tabs = [ctrl.cmpTabMain, ctrl.cmpTabReviews, ctrl.cmpTabDetails, ctrl.cmpTabQuestions];
        const tabBtns = [ctrl.btnTabMain, ctrl.btnTabReviews, ctrl.btnTabDetails, ctrl.btnTabQuestions];
        tabs.forEach(t => t.hide());
        tabBtns.forEach(b => b.removeClass('active'));
        btn.addClass('active');
        tabs[tabBtns.indexOf(btn)].show();
    }
}
exports.StateProduct = StateProduct;
StateProduct.StateName = "product";
//# sourceMappingURL=StateProduct.js.map